'use client';

import Link from 'next/link';
import { FC, useState } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { ChevronRight } from '@eqi-investimentos/icons/web';
import { Flex, Text, Skeleton } from '@eqi-investimentos/react';
import { CardOpportunityProps } from '../../interface/secondaries';
import { PATHS } from '@/config/paths';
import { useGetIntermediations } from '@/modules/Secondaries/http/client/useGetIntermediations';
import { WidgetContainer } from '@/components/molecules/Widget/Container';
import { getCookie } from '@/utils/cookies';
import { IfRender } from '@/utils/jsx';
import { CardOpportinityProduct } from '../CardOpportunityProduct';
import { DisclaimerMarket, HAS_VIEWED_DISCLAIMER_OPPORTUNITY_WIDGET_COOKIE_KEY } from '../DisclaimerMarket';
import { DrawerDetailsOpportunity } from '../DrawerDetailsOpportunity';
export const OpportunitiesWidget: FC<OpportunitiesWidgetProps> = ({
  isHub,
  handleChangeTab
}) => {
  const {
    t
  } = useTranslation('common');
  const [alreadyViewDisclaimer] = useState(() => getCookie(HAS_VIEWED_DISCLAIMER_OPPORTUNITY_WIDGET_COOKIE_KEY) === 'true');
  const [opportunityToView, setOpportunityToView] = useState<CardOpportunityProps>({});
  const {
    data: intermediationsData = {
      data: []
    },
    isFetching
  } = useGetIntermediations();
  const handleOpenDetails = (data: CardOpportunityProps) => {
    setOpportunityToView(data);
    window.dispatchEvent(new Event(`open-chakra-modal-${OPPORTUNITY_SECONDARIES_INTERMEDIATIONS_DETAILS_DRAWER_ID}`));
  };
  if (!intermediationsData?.data.length) return <></>;
  return <Flex direction="column" mt={alreadyViewDisclaimer ? '0' : 'xl'} data-sentry-element="Flex" data-sentry-component="OpportunitiesWidget" data-sentry-source-file="index.tsx">
      <DrawerDetailsOpportunity id={OPPORTUNITY_SECONDARIES_INTERMEDIATIONS_DETAILS_DRAWER_ID} data={opportunityToView} data-sentry-element="DrawerDetailsOpportunity" data-sentry-source-file="index.tsx" />

      <WidgetContainer containerId={WIDGET_OPPORTUNITIES_INTERMEDIATIONS_ID} showTitles={false} containerTitleProps={{
      h: alreadyViewDisclaimer ? '1.25rem' : '2.5rem'
    }} containerSxProps={{
      '& .swiper-slide': {
        _last: {
          pr: '2xl'
        }
      },
      '& > div > div': {
        _first: {
          pr: '2xl'
        }
      },
      '.swiper-wrapper': {
        mt: alreadyViewDisclaimer ? 0 : '2xl'
      }
    }} customTitle={<Flex flexDir="column" alignItems="start" gap="m" pb={alreadyViewDisclaimer ? 'l' : 'xl'}>
            <Flex gap="l">
              <Text size="2xl">
                {t(`widgets.secondariesOpportunities.title`)}
              </Text>
              <Flex as={Link} href={isHub ? '#' : PATHS?.investments?.index} w="auto" h="auto" onClick={e => {
          if (isHub && handleChangeTab) {
            e.stopPropagation();
            handleChangeTab();
          }
        }} alignItems="center" justifyContent="center">
                <Text size="l" color="content.brand" textTransform="capitalize">
                  {t(`attributes.seeAll`)}
                </Text>
                <ChevronRight boxSize="1.25rem" color="content.brand" />
              </Flex>
            </Flex>
            <IfRender condition={!alreadyViewDisclaimer}>
              <DisclaimerMarket />
            </IfRender>
          </Flex>} data-sentry-element="WidgetContainer" data-sentry-source-file="index.tsx">
        {isFetching ? Array.from({
        length: 10
      }).map((_, idx) => <Skeleton key={idx} w="21.75rem" h="18.75rem" borderRadius="xs" />) : intermediationsData?.data.map(card => {
        return <Flex key={card.id} w="21.75rem">
                  <CardOpportinityProduct data={card} handelViewDetails={handleOpenDetails} />
                </Flex>;
      })}
      </WidgetContainer>
    </Flex>;
};
const WIDGET_OPPORTUNITIES_INTERMEDIATIONS_ID = 'opportunities_intermediations_widget_id';
export const OPPORTUNITY_SECONDARIES_INTERMEDIATIONS_DETAILS_DRAWER_ID = 'opportunity-secondaries-intermediations-details-drawer';
interface OpportunitiesWidgetProps {
  isHub?: boolean;
  handleChangeTab?: () => void;
}